module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/069-british-indian-ocean-territory-c84f1f581b6b84a1c1fcd74081590494.svg";